export default __webpack_public_path__ + "static/media/servicies_tablet.bg.b98c7a77.jpg";